// 自动生成，勿手改。由 tools/ctc-context/extract_frontend_map.py 从 route + zh-CN i18n 抽取。
// 刷新：改了路由/中文后重跑抽取器即可覆盖本文件。
export const CTC_FRONTEND_MAP = `# CTC 前端功能地图（站点 → 页面，自动抽取自 route + zh-CN i18n）


## 站点：after-sale

- 售后反馈管理  \`/after-sale\`  [AfterSale]
  - 售后分析  \`/after-sale/after-sales-analysis\`  [AFTER_SALES_ANALYSIS]
  - 售后数据  \`/after-sale/after-sales-data\`  [AFTER_SALES_DATA]
  - 反馈管理  \`/after-sale/feedback\`  [FEEDBACK_MANAGEMENT]

## 站点：after-sale-quality

- 售后质量管理  \`/after-sale-quality\`  [AfterSaleQuality]
  - 客诉看板  \`/after-sale-quality/dashboard\`  [AfterSaleQualityDashboard]
  - 客诉源数据  \`/after-sale-quality/source-data\`  [AfterSaleQualitySourceData]
  - 激活数录入  \`/after-sale-quality/base-number\`  [AfterSaleQualityBaseNumber]
  - 问题管理  \`/after-sale-quality/issue\`  [AfterSaleQualityIssue]

## 站点：development

- 研发质量  \`/development\`  [Development]
  - 质量看板  \`/development/dashboard\`  [DevelopmentDashboard]
  - 版本对比  \`/development/dashboard/version\`  [DevelopmentDashboardVersion]
  - 质量报告  \`/development/dashboard/report\`  [DevelopmentDashboardReport]
  - 需求列表  \`/development/dev/demand-list\`  [DevelopmentDemandList]
  - 提测记录  \`/development/dev/test-record-list\`  [DevelopmentTestRecordList]
  - 测试报告  \`/development/dev/test-report-list\`  [DevelopmentTestReportList]
  - 事故复盘  \`/development/accident-review\`  [CloudtestAccidentReview]
  - 性能报告  \`/development/client-performance-report\`  [DevelopmentClientPerformanceReport]
  - client_performance_case_detail  \`/development/client-performance-case-detail\`  [DevelopmentClientPerformanceCaseDetail]
  - UI自动化报告  \`/development/ui-automation-report\`  [DevelopmentUIAutomationReport]

## 站点：issue

- 缺陷管理  \`/issue\`  [Issue]
  - 仪表盘  \`/issue/dashboard\`  [IssueDashboard]
  - 问题列表  \`/issue/list\`  [IssueList]
  - 问题详情  \`/issue/detail/:issueKey\`  [IssueDetail]
  - 设置  \`/issue/setting\`  [IssueSetting]
    - 字段配置  \`/issue/setting/field-config\`  [IssueSettingFieldConfig]
    - 问题模板配置  \`/issue/setting/template-config\`  [IssueSettingTemplateConfig]
    - 模板方案配置  \`/issue/setting/template-scheme-config\`  [IssueSettingSchemeConfig]
    - 项目配置  \`/issue/setting/project-config\`  [IssueSettingProjectConfig]
    - 部门-责任方映射  \`/issue/setting/dept-responsible-mapping\`  [IssueSettingDeptResponsibleMapping]
    - 部门归并规则  \`/issue/setting/dept-rollup-rule\`  [IssueSettingDeptRollupRule]
  - 飞书项目推送设置  \`/issue/feishu-work-item-setting\`  [IssueFeishuWorkItemSetting]

## 站点：my-dashboard

- 我的看板  \`/my-dashboard\`  [MyDashboard]
  - 自定义看板  \`/my-dashboard/customer-dashboard\`  [CustomerDashboard]
  - 看板管理  \`/my-dashboard/dashboard-manage\`  [DashboardManage]

## 站点：precision

- 精准测试服务  \`/precision\`  [Precision]
  - 覆盖率任务  \`/precision/cover-task\`  [PrecisionCoverTask]
    - 任务列表  \`/precision/cover-task\`  [PrecisionCoverTaskList]
    - 接口覆盖率列表  \`/precision/cover-task/:id/api-report\`  [PrecisionCoverTaskApiReport]
    - 全量覆盖率  \`/precision/cover-task/:id/full-coverage\`  [PrecisionCoverTaskFull]
    - 增量覆盖率  \`/precision/cover-task/:id/increment-coverage\`  [PrecisionCoverTaskIncrement]
  - PrecisionCaseRecommend  \`/precision/case-recommend\`  [PrecisionCaseRecommend]

## 站点：precision-new

- 精准测试（新）  \`/precision-new\`  [PrecisionNew]
  - 飞书文档  \`/precision-new/feishu-document\`  [PrecisionNewFeishuDocument]
  - 文档分析  \`/precision-new/feishu-document/document-analyze/:documentId\`  [PrecisionNewDocumentAnalyze]
  - 知识图谱  \`/precision-new/knowledge-graph\`  [PrecisionNewKnowledgeGraph]
  - 知识图谱  \`/precision-new/knowledge-graph/:documentId\`  [PrecisionNewKnowledgeGraphForDocument]
  - 覆盖率报告  \`/precision-new/coverage-report/:id\`  [PrecisionNewCoverageReportDetail]
  - AI分析中  \`/precision-new/analyzing\`  [PrecisionNewAnalyzing]
  - 用例推荐（AI）  \`/precision-new/case-recommend\`  [PrecisionNewCaseRecommend]
  - 测试计划  \`/precision-new/test-plan\`  [PrecisionNewTestPlan]
  - 测试计划详情  \`/precision-new/test-plan/detail/:project/:versionId?/:id?\`  [PrecisionNewTestPlanDetail]
  - 测试用例  \`/precision-new/test-case-generation\`  [PrecisionNewTestCaseGeneration]
  - 代码绑定  \`/precision-new/code-binding\`  [PrecisionNewCodeBinding]
  - 影响分析  \`/precision-new/impact-analysis\`  [PrecisionNewImpactAnalysis]
  - 接口服务  \`/precision-new/pytest/projects\`  [PytestProjects]
  - reports  \`/precision-new/pytest/projects/all-reports\`  [PytestAllReports]
  - 项目详情  \`/precision-new/pytest/projects/:projectId\`  [PytestProjectDetail]
    - 用例管理  \`/precision-new/pytest/projects/:projectId/cases\`  [PytestProjectCases]
    - YAML编辑器  \`/precision-new/pytest/projects/:projectId/editor\`  [PytestProjectEditor]
    - 测试执行  \`/precision-new/pytest/projects/:projectId/execute\`  [PytestProjectExecute]
    - 测试报告  \`/precision-new/pytest/projects/:projectId/reports\`  [PytestReports]
    - 报告详情  \`/precision-new/pytest/projects/:projectId/reports/:executionId\`  [PytestReportDetail]
    - artifacts  \`/precision-new/pytest/projects/:projectId/artifacts\`  [PytestReceivedArtifacts]

## 站点：production

- 生产质量管理  \`/production\`  [Production]
  - 看板  \`/production/dashboard\`  [ProductionDashboard]
    - 来料质量看板  \`/production/dashboard/material-dashboard\`  [ProductionDashboardMaterial]
    - 供应商质量看板  \`/production/dashboard/supplier-dashboard\`  [ProductionDashboardSupplier]
    - 制程质量看板  \`/production/dashboard/produce-dashboard\`  [ProductionDashboardProduce]
  - 来料  \`/production/material\`  [ProductionMaterial]
    - WMS-收料单  \`/production/material/wms-receive-bill\`  [ProductionMaterialWmsReceiveBill]
    - K3-收料单  \`/production/material/receive-bill\`  [ProductionMaterialReceiveBill]
    - 来料检验单  \`/production/material/inspect-order/list/:tab?\`  [ProductionMaterialInspectOrderList]
    - 来料检验单据  \`/production/material/inspect-order/detail/:billNo\`  [ProductionMaterialInspectOrderDetail]
    - 来料问题库  \`/production/material/issue\`  [ProductionMaterialBug]
    - 来料检验方案  \`/production/material/inspect-scheme/:tab?\`  [ProductionMaterialInspectScheme]
    - AI 创建来料检验方案  \`/production/material/inspect-scheme/ai\`  [ProductionMaterialInspectSchemeViewer]
    - 样品管理  \`/production/material/samples\`  [ProductionMaterialSamples]
  - ORT测试  \`/production/ort-test\`  [ProductionORTTest]
  - ORT测报告  \`/production/ort-test-detail/:id\`  [ProductionORTTestReport]
  - 供应商  \`/production/supplier\`  [ProductionSupplier]
    - 供应商审核(旧)  \`/production/supplier/check-old\`  [ProductionSupplierCheck]
    - 供应商审核  \`/production/supplier/check\`  [ProductionSupplierAudit]
    - 供应商审核详情  \`/production/supplier/check/:id\`  [ProductionSupplierCheckDetail]
    - 供应商跟踪  \`/production/supplier/track\`  [ProductionSupplierTrack]
    - 供应商绩效  \`/production/supplier/evaluate\`  [ProductionSupplierEvaluate]
    - 供应商列表  \`/production/supplier/supplier-list\`  [ProductionSettingSupplier]
    - 供应商模版配置  \`/production/supplier/stencil-config\`  [ProductionSupplierStencilConfig]
  - 出货  \`/production/shipments\`  [ProductionShipments]
    - K3出货检验  \`/production/shipments/inspect-order\`  [ProductionShipmentsInspectOrder]
    - 出货检验规范  \`/production/shipments/inspect-standard\`  [ProductionShipmentsInspectStandard]
    - 出货单明细  \`/production/shipments/inspect-detail\`  [ProductionShipmentsInspectDetail]
    - WMS出货检验单  \`/production/shipments/wms-inspect-order\`  [ProductionShipmentsWmsInspectOrder]
    - WMS检验单明细  \`/production/shipments/wms-inspect-detail\`  [ProductionShipmentsWmsInspectDetail]
  - 制程问题库  \`/production/produce-issue\`  [ProduceIssue]
  - 设置  \`/production/setting\`  [ProductionSetting]
    - 不良分类  \`/production/setting/bad-category\`  [ProductionSettingBadCategory]
    - 不良对策  \`/production/setting/bad-measures\`  [ProductionSettingMeasures]
    - 异常归属  \`/production/setting/bad-attribution\`  [ProductionSettingAttribution]
    - IQC分配逻辑  \`/production/setting/iqc-assign-logic\`  [ProductionSettingIqcAssignLogic]
    - 关注项目  \`/production/setting/focus-projects\`  [ProductionSettingFocusProjects]
    - 不良率目标  \`/production/setting/material-ng-target\`  [ProductionSettingMaterialNgTarget]

## 站点：project

- 项目/产品空间  \`/project/:pkey\`  [Project]
  - 看板  \`/project/:pkey/dashboard\`  [ProjectDashboard]
  - 研发测试  \`/project/:pkey/dev\`  [ProjectDev]
    - 需求管理  \`/project/:pkey/dev/demand-management/:tab?\`  [ProjectDemandManage]
    - 产品需求列表详情  \`/project/:pkey/dev/productDemandList-detail/:type/:id\`  [ProductAndUIDemandListDetail]
    - 产品需求AI  \`/project/:pkey/dev/productDemandAi/:id\`  [ProductDemandAI]
    - 测试方案  \`/project/:pkey/dev/test-programme\`  [ProjectTestProgramme]
    - 项目提测  \`/project/:pkey/dev/submit-test\`  [ProjectSubmitTest]
    - 测试计划  \`/project/:pkey/dev/test-plan\`  [ProjectTestPlan]
    - 测试计划详情  \`/project/:pkey/dev/test-plan/test-plan-detail/:project/:versionId?/:id?\`  [ProjectTestPlanDetail]
    - 测试计划报告  \`/project/:pkey/dev/test-plan/test-plan-report/:planId?\`  [ProjectTestPlanReport]
    - 测试报告  \`/project/:pkey/dev/test-report\`  [ProjectTestReport]
    - 测试报告详情  \`/project/:pkey/dev/test-management/test-report-detail/:tab/:id?\`  [ProjectTestReportDetail]
    - 提测记录详情  \`/project/:pkey/dev/test-management/test-record-detail/:project/:version\`  [ProjectTestRecordDetail]
    - 自动化测试  \`/project/:pkey/dev/auto-test\`  [ProjectAutoTest]
    - 测试用例  \`/project/:pkey/dev/testcase\`  [CloudtestTestCase]
  - 转阶段评审  \`/project/:pkey/tr\`  [ProjectTRReview]
    - 转阶段评审  \`/project/:pkey/tr/old\`  [OldProjectTRReview]
    - 评审标准受控  \`/project/:pkey/tr/standards-controlled\`  [StandardsControlled]
    - 评审标准库  \`/project/:pkey/tr/new\`  [NewProjectTRReview]
    - 评审标准模块库  \`/project/:pkey/tr/module\`  [ProjectTrModule]
  - 评审记录详情  \`/project/:pkey/tr/detail/:recordId\`  [ProjectTRReviewDetail]
  - 质检  \`/project/:pkey/inspect\`  [ProjectInspect]
    - 巡检检验单  \`/project/:pkey/inspect/inspection-checklist\`  [ProjectInspectionChecklist]
    - 整机检验单  \`/project/:pkey/inspect/machine\`  [ProjectInspectMachine]
    - 包装检验单  \`/project/:pkey/inspect/package\`  [ProjectInspectPackage]
    - 包装自动检验单  \`/project/:pkey/inspect/package-auto\`  [ProjectInspectPackageAuto]
  - 质检标准  \`/project/:pkey/inspect-standard\`  [ProjectInspectStandard]
    - 巡检检验规范  \`/project/:pkey/inspect-standard/process\`  [ProjectInspectStandardProcess]
    - 整机检验规范  \`/project/:pkey/inspect-standard/machine\`  [ProjectInspectStandardMachine]
    - 包装检验规范  \`/project/:pkey/inspect-standard/finish\`  [ProjectInspectStandardFinish]
  - 问题列表  \`/project/:pkey/issue\`  [ProjectIssue]
    - 研发问题  \`/project/:pkey/issue/list\`  [ProjectIssueList]
    - 研发问题详情  \`/project/:pkey/issue/detail/:issueKey\`  [ProjectIssueDetail]
    - 来料问题  \`/project/:pkey/issue/production-material\`  [ProjectIssueProductionMaterial]
    - 制程问题  \`/project/:pkey/issue/production-process\`  [ProjectIssueProductionProcess]
    - 试产问题  \`/project/:pkey/issue/trial-production\`  [ProjectIssueTrialProduction]
    - 风险  \`/project/:pkey/issue/risk\`  [ProjectIssueRisk]
  - 返工维修  \`/project/:pkey/rr\`  [ProjectRR]
    - 维修单  \`/project/:pkey/rr/repair-list\`  [ProjectRepairList]
    - 返工单  \`/project/:pkey/rr/rework-list\`  [ProjectReworkList]
  - 设置  \`/project/:pkey/setting\`  [ProjectSetting]
    - 模块管理  \`/project/:pkey/setting/components\`  [ProjectSettingComponents]
    - 版本管理  \`/project/:pkey/setting/version\`  [ProjectSettingVersion]
    - 生产设置  \`/project/:pkey/setting/product\`  [ProjectSettingProduct]
    - 评审设置  \`/project/:pkey/setting/tr\`  [ProjectSettingTR]
    - BOM  \`/project/:pkey/setting/bom\`  [ProjectSettingBom]
    - 项目设置  \`/project/:pkey/setting/system\`  [ProjectSettingSystem]

## 站点：system

- 系统后台管理  \`/system\`  [System]
  - 数据监控  \`/system/data-monitoring\`  [SystemDataMonitoring]
    - 需求文档 AI  \`/system/data-monitoring/demand-ai\`  [SystemDataMonitoringDemandAi]
  - 用户管理  \`/system/user-management\`  [SystemUserManagement]
    - 系统用户  \`/system/user-management/user\`  [SystemUserManagementUser]
    - 角色管理  \`/system/user-management/role\`  [SystemUserManagementRole]
    - 用户集管理  \`/system/user-management/collection\`  [SystemUserManagementCollection]
    - 组织管理  \`/system/user-management/organization\`  [SystemUserManagementOrganization]
  - 项目管理  \`/system/project-management\`  [SystemProjectManagement]
    - 产品线  \`/system/project-management/line\`  [SystemProjectManagementProductLine]
    - 产品系列  \`/system/project-management/series\`  [SystemProjectManagementSeries]
    - 系统项目  \`/system/project-management/project\`  [SystemProjectManagementProject]
    - 项目排序  \`/system/project-management/sort\`  [SystemProjectManagementProjectSort]
  - 权限管理  \`/system/permission\`  [SystemPermissionManagement]
    - 菜单权限  \`/system/permission/menu\`  [SystemPermissionManagementMenu]
    - 功能权限  \`/system/permission/function\`  [SystemPermissionManagementFunction]
  - 通知管理  \`/system/notification-management\`  [SystemNotificationManagement]
  - AI 工单审核  \`/system/ai-work-item\`  [SystemAiWorkItem]
  - 系统工具  \`/system/tools\`  [SystemTools]
    - 模型管理  \`/system/tools/models\`  [SystemToolModelManagement]
    - 客户端管理  \`/system/tools/clients\`  [SystemToolClientManagement]`;
